(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(scope) {
      (scope || document).querySelectorAll('[data-hero-carousel]').forEach(function (root) {
        if (root.dataset.heroInit) return;
        var slides = root.querySelectorAll('[data-hero-slide]');
        if (slides.length < 2) return; /* single image: leave it static */
        root.dataset.heroInit = '1';
        root.classList.add('is-enhanced');

        var dots = root.querySelectorAll('[data-hero-dot]');
        var speed = parseInt(root.getAttribute('data-speed'), 10) || 4000;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var auto = root.hasAttribute('data-autoplay') && !reduce;
        var current = 0;
        var timer = null;

        function go(i) {
          i = (i + slides.length) % slides.length;
          if (i === current) return;
          slides[current].classList.remove('is-active');
          slides[current].setAttribute('aria-hidden', 'true');
          if (dots[current]) { dots[current].classList.remove('is-active'); dots[current].setAttribute('aria-selected', 'false'); }
          current = i;
          slides[current].classList.add('is-active');
          slides[current].removeAttribute('aria-hidden');
          if (dots[current]) { dots[current].classList.add('is-active'); dots[current].setAttribute('aria-selected', 'true'); }
        }

        function stop() { if (timer) { clearInterval(timer); timer = null; } }
        function start() { if (auto && !timer) { timer = setInterval(function () { go(current + 1); }, speed); } }

        dots.forEach(function (dot) {
          dot.addEventListener('click', function () { go(parseInt(dot.getAttribute('data-hero-dot'), 10)); stop(); start(); });
        });
        var prev = root.querySelector('[data-hero-prev]');
        var next = root.querySelector('[data-hero-next]');
        if (prev) prev.addEventListener('click', function () { go(current - 1); stop(); start(); });
        if (next) next.addEventListener('click', function () { go(current + 1); stop(); start(); });

        root.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { go(current - 1); stop(); start(); }
          else if (e.key === 'ArrowRight') { go(current + 1); stop(); start(); }
        });

        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
        root.addEventListener('focusin', stop);
        root.addEventListener('focusout', start);
        document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });

        start();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initHero(); });
    } else {
      initHero();
    }
    document.addEventListener('shopify:section:load', function (e) { initHero(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- click-to-play videos ---- */
    function initVideos(scope) {
      (scope || document).querySelectorAll('[data-vr-frame]').forEach(function (frame) {
        if (frame.dataset.vrInit) return;
        var video = frame.querySelector('video');
        var btn = frame.querySelector('[data-vr-play]');
        if (!video || !btn) return;
        frame.dataset.vrInit = '1';
        frame.classList.add('is-enhanced');
        btn.addEventListener('click', function () {
          frame.classList.add('is-playing');
          var p = video.play();
          if (p && typeof p.catch === 'function') { p.catch(function () {}); }
        });
      });
    }

    /* ---- "show more" on long reviews ---- */
    function initMore(scope) {
      (scope || document).querySelectorAll('[data-vr-more]').forEach(function (btn) {
        if (btn.dataset.vrInit) return;
        var quote = btn.previousElementSibling;
        if (!quote || !quote.hasAttribute('data-vr-quote')) return;
        btn.dataset.vrInit = '1';
        requestAnimationFrame(function () {
          if (quote.scrollHeight - quote.clientHeight > 4) { btn.hidden = false; }
        });
        btn.addEventListener('click', function () {
          var expanded = quote.classList.toggle('is-expanded');
          btn.textContent = expanded ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
        });
      });
    }

    /* ---- horizontal carousel (native scroll + snap) ---- */
    function initCarousel(scope) {
      (scope || document).querySelectorAll('[data-vr-carousel]').forEach(function (root) {
        if (root.dataset.vrcInit) return;
        var track = root.querySelector('[data-vrc-track]');
        if (!track || track.children.length === 0) return;
        root.dataset.vrcInit = '1';
        root.classList.add('is-enhanced');

        var slides = Array.prototype.slice.call(track.children);
        var prev = root.querySelector('[data-vrc-prev]');
        var next = root.querySelector('[data-vrc-next]');
        var dotsWrap = root.querySelector('[data-vrc-dots]');
        var dots = Array.prototype.slice.call(root.querySelectorAll('[data-vrc-dots] .pl-vrc__dot'));
        var behavior = reduceMotion ? 'auto' : 'smooth';

        function maxScroll() {
          return Math.max(0, track.scrollWidth - track.clientWidth);
        }
        // scrollLeft that brings slide i flush to the track's start edge (clamped
        // so the last slides — which can't reach the start when several columns
        // are visible — resolve to the real end of the scroll range).
        function targetFor(i) {
          var slide = slides[i];
          if (!slide) return 0;
          var t = track.scrollLeft + (slide.getBoundingClientRect().left - track.getBoundingClientRect().left);
          return Math.max(0, Math.min(Math.round(t), maxScroll()));
        }
        // Active slide = the one whose left edge sits closest to the track's left
        // edge; snap to the last slide once we've scrolled to the very end.
        function currentIndex() {
          if (track.scrollLeft >= maxScroll() - 1) return slides.length - 1;
          var left = track.getBoundingClientRect().left;
          var best = 0;
          var bestDist = Infinity;
          slides.forEach(function (s, i) {
            var d = Math.abs(s.getBoundingClientRect().left - left);
            if (d < bestDist) { bestDist = d; best = i; }
          });
          return best;
        }
        function goTo(i) {
          i = Math.max(0, Math.min(slides.length - 1, i));
          track.scrollTo({ left: targetFor(i), behavior: behavior });
        }
        // exposed so the Theme Editor listener can drive this carousel
        root.vrcApi = { slides: slides, goTo: goTo };

        if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
        if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
        dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });

        // Keyboard: arrow / home / end move between dots (WAI-ARIA tablist).
        if (dotsWrap) {
          dotsWrap.addEventListener('keydown', function (e) {
            var i = dots.indexOf(document.activeElement);
            if (i < 0) return;
            var to = -1;
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { to = Math.min(dots.length - 1, i + 1); }
            else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { to = Math.max(0, i - 1); }
            else if (e.key === 'Home') { to = 0; }
            else if (e.key === 'End') { to = dots.length - 1; }
            if (to >= 0) { e.preventDefault(); dots[to].focus(); goTo(to); }
          });
        }

        function sync() {
          var idx = currentIndex();
          dots.forEach(function (dot, i) {
            var on = i === idx;
            dot.classList.toggle('is-active', on);
            dot.setAttribute('aria-selected', on ? 'true' : 'false');
            dot.tabIndex = on ? 0 : -1; // roving tabindex
          });
          if (prev) prev.disabled = track.scrollLeft <= 1;
          if (next) next.disabled = track.scrollLeft >= maxScroll() - 1;
        }
        var raf;
        track.addEventListener('scroll', function () {
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(sync);
        });
        window.addEventListener('resize', sync);
        sync();

        if (root.hasAttribute('data-autoplay') && !reduceMotion) {
          var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
          var timer = null;
          var start = function () { if (!timer) timer = setInterval(function () {
            var i = currentIndex();
            goTo(i >= slides.length - 1 ? 0 : i + 1);
          }, speed); };
          var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
          root.addEventListener('mouseenter', stop);
          root.addEventListener('mouseleave', start);
          root.addEventListener('focusin', stop);
          root.addEventListener('focusout', start);
          document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
          start();
        }
      });
    }

    /* ---- Theme Editor: reveal the block being added/selected ---- */
    function initEditor() {
      if (!(window.Shopify && Shopify.designMode)) return;
      if (document.documentElement.dataset.vrEditorInit) return;
      document.documentElement.dataset.vrEditorInit = '1';
      // Fired on the block's own element; bubbles to document. Covers both
      // ADD (newly loaded block is auto-selected) and SELECT of any block.
      document.addEventListener('shopify:block:select', function (e) {
        var el = e.target;
        var slide = el && el.closest ? el.closest('.pl-vrc__slide') : null;
        if (!slide) return;
        var root = slide.closest('[data-vr-carousel]');
        if (!root || !root.vrcApi) return;
        var i = root.vrcApi.slides.indexOf(slide);
        if (i >= 0) { root.vrcApi.goTo(i); }
      });
    }

    function initAll(scope) {
      initVideos(scope);
      initMore(scope);
      initCarousel(scope);
      initEditor();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
